import React from 'react';
import {
  Control,
  Controller,
  RegisterOptions,
  get,
} from 'react-hook-form';
import {
  Chip,
  FormControl,
  Input,
  InputBaseComponentProps,
  InputLabel,
  Select,
  SelectProps,
} from '@mui/material';

type CustomTextFieldProps = SelectProps & {
  errors?: Record<string, any>;
  control: Control<any>;
  rules?: Exclude<
    RegisterOptions,
    'valueAsNumber' | 'valueAsDate' | 'setValueAs'
  >;
  defaultValue?: Array<unknown>;
  name: string;
  labelFunction?: (value: string) => string;
  helperText?: string;
};

// eslint-disable-next-line max-lines-per-function
export const CustomMultiSelectField: React.FC<CustomTextFieldProps> = ({
  errors,
  name,
  control,
  children,
  defaultValue,
  rules,
  helperText,
  label,
  labelFunction,
  ...rest
}) => {
  return (
    <Controller
      control={control}
      defaultValue={defaultValue}
      rules={rules}
      name={name}
      render={({ field: { value, onChange, ...renderProps } }) => (
        <FormControl
          size={rest.inputProps?.size || 'medium'}
          fullWidth
          variant="outlined"
        >
          <InputLabel>{label}</InputLabel>
          <Select
            multiple
            value={value ?? []}
            label={label}
            onChange={onChange}
            {...renderProps}
            {...rest}
          >
            {children}
          </Select>
        </FormControl>
      )}
    />
  );
};
